import React from 'react';
import { about } from '../data/pages';
import Reveal from './Reveal';

// Wide cards with a generated graphic on the right (stands in for the reference's photos).
function Target() {
  return (
    <svg viewBox="0 0 300 200" aria-hidden="true">
      <g fill="none" stroke="#80c342">
        {[90, 68, 46, 24].map((r, i) => <circle key={r} cx="215" cy="100" r={r} strokeOpacity={0.25 + i * 0.18} strokeWidth="3" />)}
        <path d="M20 100h195" strokeWidth="3" strokeOpacity=".8" />
        <path d="M20 100l18-9v18z" fill="#80c342" />
      </g>
      <circle cx="215" cy="100" r="7" fill="#80c342" />
    </svg>
  );
}

function Lens() {
  return (
    <svg viewBox="0 0 300 200" aria-hidden="true">
      <g fill="none" stroke="#80c342">
        <path d="M60 100c40-55 140-55 190 0-50 55-150 55-190 0z" strokeWidth="3" strokeOpacity=".7" />
        <circle cx="155" cy="100" r="38" strokeWidth="3" strokeOpacity=".8" />
        <circle cx="155" cy="100" r="20" strokeWidth="3" strokeOpacity=".5" />
      </g>
      <circle cx="155" cy="100" r="8" fill="#80c342" />
    </svg>
  );
}

export default function MissionVision() {
  const cards = [
    { title: 'Our Mission', text: about.mission, art: <Target /> },
    { title: 'Our Vision', text: about.vision, art: <Lens /> },
  ];
  return (
    <div className="mv">
      {cards.map((c, i) => (
        <Reveal key={c.title} delay={i * 90}>
          <div className="mv__card">
            <div className="mv__text"><h3>{c.title}</h3><p>{c.text}</p></div>
            <div className="mv__art">{c.art}</div>
          </div>
        </Reveal>
      ))}
    </div>
  );
}
